var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.focused
      ? _c("input", {
          class: _vm.$style.distanceInput,
          attrs: { type: "text" },
          domProps: { value: _vm.distance },
          on: {
            change: function ($event) {
              return _vm.handleChanged($event)
            },
            blur: _vm.onBlur,
            keydown: _vm.handleKeys,
          },
        })
      : _c(
          "div",
          { class: _vm.$style.distanceInput, on: { click: _vm.onFocus } },
          [
            _c("span", [_vm._v(_vm._s(_vm.distance))]),
            _c("span", { class: _vm.$style.sup }, [
              _vm._v(_vm._s(_vm.subUnit)),
            ]),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }